module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Downloaded file-c778250b68c366a5ea3162fe40a10c41.svg";